var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label-size":"lg","label":_vm.label,"label-cols":"4"}},[_c('b-collapse',{attrs:{"visible":_vm.open}},[_vm._t("open")],2),_c('b-collapse',{attrs:{"visible":!_vm.open}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }